import type {Props} from '../types/types';
import * as React from 'react';
import {View} from '../libs/WebComponents';
import { do_actions } from '../utils/FiltersAndActions';

let scrolling =false;
let pressTimer = 0;
let scrollPosition= {x:0, y:0};
const currentPosition = {x:0,y:0};
const PressScrollView = (props: {updatePoint: Function, children: any, location: {x: number, y: number} })=>{

   const popupRef = React.useRef(null as null | HTMLDivElement);
   const mapContainerRef = React.useRef(null as null | HTMLDivElement);

   React.useEffect(()=>{
      setTimeout(()=>{
      do_actions('getPopupRef', {ref:popupRef});
      if (popupRef.current)
      {
         popupRef.current.onmousedown = _startMove;
         popupRef.current.onmouseup = _stopMove;
         popupRef.current.onmousemove = _onMove;
         popupRef.current.onmouseleave = _stopMove;
         popupRef.current.ontouchstart = _startMove;
         popupRef.current.ontouchend = _stopMove;
         popupRef.current.ontouchmove = _onMove;
         popupRef.current.ontouchcancel = _stopMove;
      }
      if (props.location){
         currentPosition.x = props.location.x;
         currentPosition.y = props.location.y;
      }
   }, 300);
   },[]);

   const _updatePoint = React.useCallback((e: any)=>{
      const boundary = mapContainerRef.current?.getBoundingClientRect();
      const offset = popupRef.current?.getBoundingClientRect();

      if (!boundary || !offset) return;
      const padding = 20;
      const x = currentPosition.x +scrollPosition.x - offset.left -padding;
      const y = currentPosition.y+ scrollPosition.y - offset.top -padding;
      if (x<0 || y<0 || x>boundary.width || y>boundary.height) {
         return;
      }
      props.updatePoint({x,y});
   },[]);

   const _stopMove = React.useCallback((e: any)=>{
      scrolling =false;
      if (popupRef.current) popupRef.current.style.cursor = '';
      if (pressTimer + 200 > Date.now()) {
         _updatePoint(e);
         return;
      }
   },[]);

   const _startMove = React.useCallback((e: any)=>{
      pressTimer = Date.now();
      scrolling = true;
      e.preventDefault();
      const {clientX, clientY} = e.touches ? e.touches[0] : e;
      const {scrollLeft,scrollTop} = popupRef.current as HTMLDivElement;

      currentPosition.x= clientX;
      currentPosition.y= clientY;
      scrollPosition.x = scrollLeft;
      scrollPosition.y = scrollTop;
   },[]);

   const _onMove = React.useCallback((e: any)=>{
      if (!scrolling) return;
      if (pressTimer + 199 > Date.now()) {
         return;
      }
      const {clientX, clientY} = e.touches ? e.touches[0] : e;
      if (popupRef.current) popupRef.current.style.cursor = 'move';

      popupRef.current?.scrollTo(scrollPosition.x + currentPosition.x-clientX , scrollPosition.y + currentPosition.y-clientY);

   },[scrolling]);

   return <View ref={mapContainerRef} className={'map-container'}>{props.children}</View>;
};


export default PressScrollView;
